import React from 'react';
import VehicleRegistration from './components/VehicleRegistration';
import MaterialLoading from './components/MaterialLoading';
import DeliverySchedule from './components/DeliverySchedule';
import i18n from '../../../../i18n';
import '../../../../styles/components/loading-management.scss';
import CleaningSchedule from './components/CleaningSchedule';
import { getLoadingManagement } from './services/LoadingManagementService';
import { toast } from 'react-toastify';

class FleetManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'deliverySchedule',
            hideSidebar: false,
            loadingData: true,
            counts: {
                deliverySchedule: 0,
                materialLoading: 0,
                houseKeeping: 0
            }
        };
    }

    componentDidMount() {
        this.fetchLoadingManagement();
    }

    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
    }

    // Pass props to each component
    renderActiveComponent = () => {
        const commonProps = {
            hideSidebar: this.state.hideSidebar,
            // Add any other common props you need
        };

        switch (this.state.activeTab) {
            case 'vehicleRegistration':
                return <VehicleRegistration
                    {...commonProps}
                    onVehicleAdded={this.handleVehicleAdded}
                />;
            case 'materialLoading':
                return <MaterialLoading
                    {...commonProps}
                    onTicketCreated={this.handleTicketCreated}
                    refreshCount={this.fetchLoadingManagement}
                />;
            case 'deliverySchedule':
                return <DeliverySchedule
                    {...commonProps}
                    onScheduleUpdated={this.handleScheduleUpdated}
                    refreshCount={this.fetchLoadingManagement}
                />;
            case 'houseKeeping':
                return <CleaningSchedule
                    {...commonProps}
                    onScheduleUpdated={this.handleScheduleUpdated}
                />;
            default:
                return <DeliverySchedule {...commonProps} />;
        }
    }

    // Example handler methods
    handleVehicleAdded = (vehicleData) => {
        console.log('Vehicle added:', vehicleData);
        // You can update state or perform other actions
    }

    handleTicketCreated = (ticketData) => {
        console.log('Ticket created:', ticketData);
        // Refresh counts when a new ticket is created
        this.fetchLoadingManagement();
    }

    handleScheduleUpdated = (scheduleData) => {
        console.log('Schedule updated:', scheduleData);
        // Refresh counts when schedule is updated
        this.fetchLoadingManagement();
    }

    fetchLoadingManagement = async () => {
        this.setState({ loadingData: true });

        try {
            const response = await getLoadingManagement();
            
            if (response.success && response.data) {
                // Assuming the backend returns data in this format:
                // response.data: {
                //   weighbridge_tickets_in_count: X,
                //   delivery_sites_t_status_count: Y,
                //   total_combined_count: Z
                // }
                
                // Or if using the enhanced version:
                // response.data.counts: {
                //   active_weighbridge_tickets: X,
                //   delivery_sites_t_status: Y,
                //   total_combined: Z
                // }
                
                // Update counts based on API response structure
                const counts = {
                    deliverySchedule: response.data.delivery_sites_t_status_count || 
                                    (response.data.counts && response.data.counts.delivery_sites_t_status) || 0,
                    materialLoading: response.data.weighbridge_tickets_in_count || 
                                   (response.data.counts && response.data.counts.active_weighbridge_tickets) || 0,
                    houseKeeping: 0 // Update this if you have an API for cleaning schedule count
                };

                this.setState({
                    counts,
                    loadingData: false
                });
            } else {
                toast.error(response.message || 'Failed to fetch loading management data');
                this.setState({ loadingData: false });
            }
        } catch (error) {
            console.error('Error fetching loading management data:', error);
            toast.error('Error loading management counts');
            this.setState({ loadingData: false });
        }
    };

    render() {
        const { activeTab, loadingData, counts } = this.state;

        return (
            <React.Fragment>
                <section className="site-visit-details-page bg-white">
                    <div className="container">
                        <div className="row">
                            <div className='col-xl-12 col-lg-12 col-md-12'>
                                <div className="fleet-management-tabs card">
                                    {/* Cards Section */}
                                    <div className="fleet-cards-container">
                                        {/* Delivery Schedule Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'deliverySchedule' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('deliverySchedule')}
                                        >
                                            <div className="fleet-card-title">
                                                 📅 {i18n.t('delivery_schedule')} <span className='fleet-card-count'>{counts.deliverySchedule}</span>
                                            </div>
                                        </div>

                                        {/* Material Loading Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'materialLoading' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('materialLoading')}
                                        >
                                            <div className="fleet-card-title">
                                                 🎫 {i18n.t('material_loading')} <span className='fleet-card-count'>{counts.materialLoading}</span>
                                            </div>
                                        </div>

                                       

                                        {/* House Keeping/Cleaning Schedule Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'houseKeeping' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('houseKeeping')}
                                        >
                                            <div className="fleet-card-title">
                                                 🧹 {i18n.t('cleaning_schedule')} <span className='fleet-card-count'>{counts.houseKeeping}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Content Section */}
                                    <div className="tab-content">
                                        {this.renderActiveComponent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default FleetManagement;